import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import cardsBg from "assets/images/common/others/cardsBg.png";
import cardProfilePic from "assets/images/common/others/cardProfilePic.png";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { useLocation, useNavigate } from "react-router-dom";
import useUtils from "hooks/useUtils";
import useUsers from "containers/user-management/useHooks";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";

const ViewExperienceAttendance = () => {
  const [event, setEvent] = useState<any>({});
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const { getEventDetailById } = useUsers();
  const navigate = useNavigate();
  const { getQueryParams } = useUtils();
  const params = getQueryParams();

  const [activeTab, setActiveTab] = useState("attendance");
  useEffect(() => {
    getEventDetailById(params?.id, setEvent);
  }, []);
  const goToBack = () => {
    navigate(-1);
  };

  const attendedUsers = event?.event?.eventSubscriptions?.filter(
    (item: any) => item?.isAttended
  );

  return (
    <div>
      <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        Attendance
      </h1>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
        <div className="flex gap-4 items-center">
          <h1 className="text-[20px] md:text-[26px] lg:text-[32px] font-bold text-primaryText">
            International Digital Art and Cyber Tech
          </h1>
          <p className="bg-peachFadeBg text-darkYellowText text-sm font-medium rounded-md px-2 py-1">
            Session
          </p>
        </div>

        {/* Tabs Section */}
        <div className="flex gap-4  mt-4">
          <button
            className={`py-2 px-4 text-base font-semibold pb-1 transition-colors duration-300  ${
              activeTab === "attendance"
                ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                : "text-mediumGrayText hover:text-lightBlueColor"
            }`}
            onClick={() => setActiveTab("attendance")}
          >
            Attendance
          </button>
          <button
            className={`py-2 px-4 text-base font-semibold pb-1 transition-colors duration-300 ${
              activeTab === "participants"
                ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                : "text-mediumGrayText hover:text-lightBlueColor"
            }`}
            onClick={() => setActiveTab("participants")}
          >
            Participants
          </button>
        </div>

        {/* Tab Content */}
        <div className="mt-4">
          {activeTab === "attendance" && (
            <div>
              <p className="text-base font-semibold text-captionText">
                Attendees ( Present )
              </p>

              <div className="flex flex-wrap items-center gap-4 py-5">
                {attendedUsers && attendedUsers.length > 0 ? (
                  attendedUsers.map((item: any, index: number) => (
                    <div
                      key={index + 1}
                      className="flex flex-col items-center justify-center p-4 min-w-[200px] min-h-[195px] cursor-pointer bg-cover bg-center bg-no-repeat border bg-clip-border rounded-3xl"
                      style={{ backgroundImage: `url(${cardsBg})` }}
                    >
                      <div className="hover:scale-110 transition-transform duration-300">
                        <img
                          className="w-[70px] h-[70px] rounded-full"
                          src={
                            item?.isAttended
                              ? concatPathWithBackendUrl(
                                  item?.profilePicUrl?.fileDownloadUri
                                )
                              : editProfilePicUser
                          }
                          alt={item?.username}
                        />
                      </div>
                      <span className="text-base font-semibold my-2 text-primaryText">
                        {item?.isAttended
                          ? `${item?.firstName} ${item?.lastName}`
                          : ""}
                      </span>
                      <span className="text-base font-semibold text-primaryText">
                        {item?.isAttended ? `${item?.username}` : ""}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="text-center w-full text-gray-500">
                    No attendees marked as present
                  </div>
                )}
              </div>
            </div>
          )}
          {activeTab === "participants" && (
            <div>
              <p className="text-base font-semibold text-captionText">
                Participants
              </p>

              <div className="flex flex-wrap items-center gap-4 py-5">
                <div className="flex flex-wrap items-center gap-4 py-5">
                  {event?.event?.eventSubscriptions?.map(
                    (item: any, index: number) => (
                      <div
                        key={index + 1}
                        className="flex flex-col items-center justify-center p-4  min-w-[200px] min-h-[195px] cursor-pointer bg-cover bg-center bg-no-repeat border  bg-clip-border rounded-3xl"
                        style={{ backgroundImage: `url(${cardsBg})` }}
                      >
                        <div className="hover:scale-110 transition-transform duration-300">
                          <img
                            className="w-[70px] h-[70px] rounded-full"
                            src={
                              item?.profilePicUrl
                                ? concatPathWithBackendUrl(
                                    item?.profilePicUrl?.fileDownloadUri
                                  )
                                : editProfilePicUser
                            }
                            alt={item?.username}
                          />
                        </div>
                        <span className="text-base font-semibold my-2 text-primaryText">
                          {`${item?.firstName} ${item?.lastName}`}
                        </span>
                        <span className="text-base font-semibold text-primaryText">
                          {item?.username}
                        </span>
                        {/* <div className="flex gap-2 items-center">
                      <span className="bg-peachFadeBg text-darkYellowText text-xs rounded-md font-medium px-3 py-1.5">
                        {item.Respectful}
                      </span>
                      <span className="bg-techGlowBg text-techGlowText text-xs rounded-md font-medium px-3 py-1.5">
                        {item.ontime}
                      </span>
                    </div> */}
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <DataNotFound
        show={!isLoading && !event?.event?.eventSubscriptions?.length}
      />
    </div>
  );
};

export default ViewExperienceAttendance;
